/**
 * OpenAI Service for AI optimization
 * Handles AI-powered optimization of CPD entries via backend API
 */

import api from '../utilities/api';

class OpenAIService {
  /**
   * Optimize diary entry content
   * @param {Object} formData - The form data to optimize
   * @returns {Promise<Object>} - Optimized content
   */
  async optimizeDiaryEntry(formData) {
    return this.callOptimizationEndpoint('diary', formData);
  }

  /**
   * Optimize supervision entry content
   * @param {Object} formData - The form data to optimize
   * @returns {Promise<Object>} - Optimized content
   */
  async optimizeSupervisionEntry(formData) {
    return this.callOptimizationEndpoint('supervision', formData);
  }

  /**
   * Optimize reflection entry content
   * @param {Object} formData - The form data to optimize
   * @returns {Promise<Object>} - Optimized content
   */
  async optimizeReflectionEntry(formData) {
    return this.callOptimizationEndpoint('reflection', formData);
  }

  /**
   * Call backend optimization endpoint
   * @param {string} type - Entry type (diary, supervision, reflection)
   * @param {Object} formData - Form data
   * @returns {Promise<Object>} - Optimized content
   */
  async callOptimizationEndpoint(type, formData) {
    return api.v2.post('ai/optimize', {
      type,
      pages: formData.pages
    }).then(response => {
      return response.body;
    }).catch(error => {
      console.error('AI optimization failed:', error);
      throw new Error(`AI optimization failed: ${error.body?.message || error.message || 'Unknown error'}`);
    });
  }


}

export default new OpenAIService();
